import setBookingCookie from './set-booking-cookie';
import isSEM from './is-sem';
import megatron from '@stencil/megatron';
import { BOOKING_REVIEW_PAGE_URL, __GI_CB__ } from '@stencil/flights-constants/src/urls';
import { SEO_SEARCH_STRING } from '@stencil/flights-constants/src/default-values';
import getUrlParams from './get-url-params';
import urlSearchParamsToObject from './url-search-params-to-object';

export async function postRepriceAddonsAPI(requestObj) {
  const url = `${__GI_CB__}/reprice-addons/`;
  const paramObj = { v: 1.5, ...requestObj }; // default flavour and v if not provided

  const params = [];
  for (const key in paramObj) {
    if (paramObj.hasOwnProperty(key)) {
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(paramObj[key]));
    }
  }
  const parameters = params.join('&');

  var header = new Headers();
  header.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8;');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  const response = await megatron({
    name: 'reprice addons api',
    headers: header,
    type: 'POST',
    url: url,
    credentials: 'include',
    requestData: parameters
    // requestData: param
  });
  if (response) {
    return response;
  }
}

export const openBookingReview = (resp, isSRP, searchParamsString) => {
  if (resp) {
    const q = new URLSearchParams(resp);
    window.open(
      `${window.location.origin}${BOOKING_REVIEW_PAGE_URL}?${q}${
        !isSRP ? `${searchParamsString}` : ''
      }`
    );
  }
};

export const openGroundUpBookingReview = (resp, isSRP, searchParamsString) => {
  const { t } = resp;
  if (t) {
    window.open(
      `${window.location.origin}${BOOKING_REVIEW_PAGE_URL}?t=${t}${
        !isSRP ? `${searchParamsString}` : ''
      }`
    );
  }
};

const goToReviewPage = async (
  flavourParam,
  bookingReviewData = {},
  travelType,
  experimentMetaData,
  hitHulk = false,
  handleHulkResponse = () => {},
  selectedFlight = {},
  isSRP = false,
  isGroundup = false,
  repriceRequestParams = null,
  searchParams = ''
) => {
  let utmParams = {};
  const flavour = flavourParam;
  const isSem = isSEM();

  const searchString = getUrlParams();
  const searchParamsString = isSem ? searchString?.replace('?', '') : `&${SEO_SEARCH_STRING}`;

  if (isSem) {
    const urlSearchParams = new window.URLSearchParams(searchString);
    const urlSearchParamsObject = urlSearchParamsToObject(urlSearchParams);
    utmParams = urlSearchParamsObject;
  } else {
    utmParams = {
      gocashoffer: true,
      // utm_source: 'google',
      gi_source: 'google',
      // utm_medium: 'organic',
      gi_medium: 'organic',
      campaign: 'organic'
    };
  }

  if (isGroundup && hitHulk) {
    const fareBreakupVersion =
      experimentMetaData && experimentMetaData['GI_FLT_FARE_BREAKUP']?.GI_FLT_FARE_BREAKUP;
    const resp = await postRepriceAddonsAPI({
      flavour,
      ...repriceRequestParams,
      v: fareBreakupVersion ? 1.6 : 1.5,
      ...(!isSRP && { ...utmParams })
    });
    openGroundUpBookingReview(resp, isSRP, `${searchParamsString}${searchParams}`);
    handleHulkResponse();
    return;
  }

  if (hitHulk) {
    const { queryParam } = bookingReviewData;
    const queryParamArr = queryParam.split('-');
    const query_data = queryParamArr.slice(0, queryParamArr.length - 1).join('-');

    const { si = {}, o = [], r = [] } = bookingReviewData.bookData || {};
    const { ri = {} } = si;
    const { rid = '' } = ri;
    const rcoms = {};
    if (o && o.length) {
      const onwFlt = o[0];
      rcoms[onwFlt.cid] =
        selectedFlight && selectedFlight.bundleIndex
          ? onwFlt.al[selectedFlight.bundleIndex].fk
          : onwFlt.fk;
    }
    if (r && r.length) {
      const retFlt = r[0];
      rcoms[retFlt.cid] = retFlt.fk;
      rcoms[retFlt.cid] =
        selectedFlight && selectedFlight.bundleIndex
          ? retFlt.al[selectedFlight.bundleIndex].fk
          : retFlt.fk;
    }
    // const resp = await postRepriceAddonsAPI({
    //   flavour,
    //   v: 1.6,
    //   query_data,
    //   rid,
    //   rcoms: JSON.stringify(rcoms),
    //   ...utmParams
    // });
    const resp = {
      flavour,
      v: 1.6,
      query_data,
      rid,
      rcoms: JSON.stringify(rcoms),
      rkeys: JSON.stringify(Object.values(rcoms)),
      ...utmParams
    };
    openBookingReview(resp, isSRP, searchParamsString);
    handleHulkResponse();
  } else {
    localStorage.setItem(
      `bookingReviewData`,
      JSON.stringify({ ...bookingReviewData, ...utmParams })
    );
    setBookingCookie(travelType);
    window.location.href = `${window.location.origin}${BOOKING_REVIEW_PAGE_URL}${
      !isSRP ? `?${searchParamsString}` : ''
    }`;
  }
};

export default goToReviewPage;
